const amTranslations = {
  "welcome": "እንኳን ደህና መጡ",
  "search": "ፍለጋ",
  "whatareyoulookingfor": "ምን እንደ አሁኑ ይፈልጋሉ?",
  "propertiesList": "ንብረቶች ማዕከል",
  "explore": "ተመልከት",
  "exploreBy": "እንዴት ትመልከታላችሁ?",
  "listView": "ዝርዝር እንደሆነ ትመልከታላችሁ",
  "mapView": "ካታትሪን እንደሆነ ትመልከታላችሁ",
  "whatAreYouLookingFor": "ምን እንደ አሁኑ ይፈልጋሉ?",
  "propertyType": "ንብረት አይነት",
  "location": "ቦታ",
  "noPropertiesFound": "ተመልከቱ ንብረቶች አልተገኙም",
  "searchForAddress": "አድራሻ፣ ከተማ፣ ወይም ቦታ ፍለጋ",
  "whatAreYouLookingForPlaceholder": "እባኮትን አድራሻ፣ ከተማ፣ ወይም ቦታ ፍለጋ",
  "availableProperties": "አሁን ባሉ ንብረቶች",
  "viewDetails": "ምስልን ማየት",
  "price": "ዋጋ",
  "LocationEthopia": "እንቁጽባብ ኢትዮጵያ",  // This is "Location Ethiopia" in Amharic

  "BuyRentSell": "ቤት ግዢ፣ ቤት ኪራይ፣ ወይም ቤት ሽያጭ በቀላሉ ይወስዱ",
  "GreatPlatform": "በማንኛውም ኮሚሽን ስለማይከፈል ቤቶቻችሁን ለመግዛት፣ ለመሸጥ፣ ወይም ለመኪና በቀላሉ ማድረግ የሚያስችል ትልቅ መድረክ ነው።",

  "locationDetails": "ቦታ መረጃ",
  "propertyDetails": "ንብረት መረጃ",
  "favorites": "እባኮትን ይምረጡ",
  "filter": "ፍለጋ",
  "welcomeback": "እንኳን ደህና መጣህ",
  "username" : "የተጠቃሚ ስም",
  "password" : "የይለፍ ቃል",
  "register" : "ይመዝገቡ",
  "createyouraccountwith" : "መለያህን ፍጠር",
  "verification" : "ማረጋገጥ",
  "viewMore": "ተጨማሪ ይመልከቱ",
  "enteryourusername": "የተጠቃሚ ስምህን አስገባ",
  "enteryourpassword": "የይለፍ ቃልዎን ያስገቡ",
  "signinwithmobilenumber" : "በተንቀሳቃሽ ስልክ ቁጥር ይግቡ",
  "forgotpassword" : "የይለፍ ቃል ረሱ",
  "Donthaveanaccount" : "መለያ የለዎትም።",
  "exploreNewProjects": "አዳዲስ ፕሮጀክቶች ተመልከት",
  "projectsNearYou": "በቅርብ ቦታ ያሉ ፕሮጀክቶች",
  "becomeAHost": "ቤት ሆስት ሆነው ሂዱ",
  "generateIncome": "ተቀላቀል ትክክለኛ እቃ ምንዛሬ እንዲኖረው",
  "featuredProperties": "ተመልከቱ የታወቁ ንብረቶች",
  "propertyNotAvailable": "ንብረቱ አልተገኘም",
  "profile": "ፕሮፋይል",
  "myProfile": "የእኔ ፕሮፋይል",
  "editProfile": "ፕሮፋይል አስተካክል",
  "name": "ስም",
  "email": "ኢሜል",
  "sendOTP" : "OTP ላክ",
  "filter" : "አጣራ",
  "enter" : "አስገባ",
  "sendto" : "ተልኳል።",
  "details" : "ዝርዝሮች",
  "phoneNumber": "ስልክ ቁጥር",
  "address": "አድራሻ",
  "language": "ቋንቋ",
  "currency": "ገንዘብ",
  "referralCode": "ማስታወቂያ ኮድ",
  "logout": "እባኮትን ውጣ",
  "changePassword": "ማሻሻያ ስልክ ቁጥር",
  "settings": "ስምንት አስተካክል",
  "updateProfile": "ፕሮፋይል አስተካክል",
  "success": "በማሳካት ታማኝ ነበር",
  "error": "አልተቻለም",
  "termsAndConditions": "ሁኔታዎች እና ሁሉንም",
  "privacyPolicy": "የግል ፖሊሲ",
  "help": "እገዛ",
  "contactUs": "ተጠቀም እና እንዲሁም በላይ",
 "renters": "50k + ተከራካሪዎች",
  "rentersDescription": "በእኛ አገልግሎት እምነታቸውን ይሰጣሉ",
  "properties": "10k+ ንብረቶች",
  "propertiesDescription": "ቤቶች ለመተከል ዝግጅት ላይ ያሉ",
  "exploreNewProjects": "አዳዲስ ፕሮጀክቶችን ተመልከት",
  "exploreNewProjectsDescription": "ከእርስዎ ቦታ በቅርብ ያሉ አንዳንድ ታዋቂ ንብረቶች",
  "exploreBy": "በምን ትመልከታላችሁ?: ",
  "listView": "ዝርዝር እንደሆነ ትመልከታላችሁ",
  "mapView": "ካታትሪን እንደሆነ ትመልከታላችሁ",
  "propertiesList": "ንብረቶች ማዕከል",
  "propertiesCount": "{count} ንብረቶች",
  "interestedInHosting": "የእራስዎን ንብረት ሆስት ለመሆን እባኮትን ተመልከቱ?",
  "generateIncome": "በማብረቅ ወይም በሽያጭ ቤቶቻችሁ ተቀላቀል ገንዘብ በማድረግ ሰማኝ ነበር",
  "becomeAHost": "እስቲ ሆስት ሁኑ",
  "footer.noSpamPromise": "አልተሰማው ተስፋ",
  "footer.areYouLandowner": "አንተ እንደ ምድር ባለቤት ነህ?",
  "footer.discoverWays": "ቤትህን በመለምከት መረጃ እና ስምምነቶችን ለመጠቀም መንገዶችን ማስተዋል። አልተሰማው ተስፋ",
  "footer.enterEmail": "ኢሜል አድራሻዎን አስገባ",
  "footer.submit": "አስገባ",
  "footer.joinLandlords": "በሌሎች 10,000+ ምድር ባለቤቶች በማኅበሩ ማኅበረሰብ ተቀላቀል",
  "footer.about": "ስለ",
  "footer.company": "ኩባንያ",
  "footer.howItWorks": "እንዴት እንደምትሰራ",
  "footer.contact": "እንዲያው",
  "footer.investors": "እንዴት ይሁን",
  "footer.resources": "መሳሪያዎች",
  "footer.blog": "ብሎግ",
  "footer.guides": "መመሪያዎች",
  "footer.faq": "ጥያቄቶች",
  "footer.helpCenter": "የእርዳታ ማኅበረሰብ",
  "footer.termsPrivacy": "የስምምነት እና ግምገማ",
  "footer.trustSafety": "እምነት እና ደህንነት",
  "footer.termsService": "የአጠቃቀም ስምምነት",
  "footer.privacyPolicy": "የግል መረጃ ፖሊሲ",
  "footer.copyright": "©2025. ሁሉም መብቶች እንደተጠበቀ",

  "terms.conditions": "ስምምነት እና ሁኔታዎች",
  "terms.text1": "በ  እንደ ተጠቃሚ በመጠቀም፣ እርስዎ ትክክለኛ መረጃ ማቅረብን እና መድረኩን በህጋዊ ምንጭ ለማጠቀም ማስተማር ስለሚሆን ማስረጃ ተሰጥቷል።",
  "terms.text2": "በምን ምንት ሁሉም የተወሰኑ በአምባው አቀባበል እንዲሁም እቅድ ማቅረብ ማኅበረሰብ ተቋማት አሳየተለኝ።",
  "terms.text3": "ተጠቃሚዎች ሁሉንም ዝርዝሮች ማረጋገጥ እና ምንም ስምምነት አቅም ወስድት ይሁንበት >ስለ ስራቸው ተጠቃሚ ድርጊት በራሱ</span>.",
  "privacy.policy": "የግል መረጃ ፖሊሲ",
  "privacy.text1": " የግል መረጃዎችን ተጠቃሚ ባለ᠋ የመሳሪያዎችን ማስተካከል አቀርቦት ማን የትኛ ሂደትንም ማቅረብ ማስሪት.",
  "privacy.text2": "እኛም በሕግ አንድ ተለቂ ትምህርቶች ሳይቀር በሐምሌዎት እና ከምርምርን በማዕከል በመተግበሪ አብራችሁ።",
  "privacy.text3": "በአፕ ተጠቃሚ ስለማኅበረሰቡን መረጃን እና መለኪያ ማስተማር የግል አስተዳደሩን ተመልከቱ።",
  "help.center": "እርዳታ ማኅበረሰብ",
  "help.text1": "በእርስዎ እንዲያውም በመላ ስምምነቶች አንድ አመንታ ይለፍቅና በማንቸት ይዘለ ለገባችሁ ማስፈለግት ማቅረብ።",
  "contact.us": "እንዲያው",
  "change.profile": "ተለዋዋጭ መክፈት",
  "remove.profile": "አሳሳቢ መክፈት",
  "profile": "መገለጫ",
  "save": "አስተዳደር",
  "edit.profile": "ትክክለኛ ማሻሻያ",
  "edit.profile.picture": "ማሻሻያ ስለ እርስዎ",
  "cancel": "እንዲሁ እንዲያሳስበት ቆረጠ",
  "save.picture": "የምስል ማሻሻያ",
  "zoom": "እንደ ሞባውት ታምክታ",
  "upload.picture": "በሚኒቴቶች ተለመዱ",
   "profile.title": "መገለጫ",
  "profile.userName": "የተጠቃሚ ስም",
  "profile.phoneNumber": "ስልክ ቁጥር",
  "profile.emailAddress": "ኢሜል አድራሻ",
  "profile.save": "አስተዳደር",
  "profile.editProfile": "ትክክለኛ ማሻሻያ",
  "profile.changeProfile": "የመለያ ለውጥ",
  "profile.removeProfile": "መለያ ማስወገድ",
  "profile.uploadPicture": "ምስል አንሳ",
  "profile.editProfilePicture": "ምስል እንደ መለኪያ",
  "profile.cancel": "ማስተናገድ",
  "profile.zoom": "እንደ ሞባውት ታምክታ",
  "profile.lastUpdated": "መጨረሻ እንደሆነ: ሴፕቴምበር 2025",
  "profile.removeProfileConfirmation": "እባክህ መለያህን ማስወገድ ትፈልጋለህ?",
  "savedProperties.title": "ተቀማጭ ንብረቶች",
  "savedProperties.errorOccurred": "ስህተት አሳየተ፡ {{error}}",
  "savedProperties.noSavedProperties": "በእርስዎ ተቀማጭ ንብረቶች አልተገኙም",
   "propertyDetails.title": "ንብረት መረጃ",
  "propertyDetails.location": "ቦታ",
  "propertyDetails.bedrooms": "መኝታ ክፍሎች",
  "propertyDetails.bathrooms": "መታጠቢያ ክፍሎች",
  "propertyDetails.area": "ቦታ",
  "propertyDetails.type": "አይነት",
  "propertyDetails.amenities": "ተጨማሪ አቅራቢዎች",
  "propertyDetails.reviews": "ምላሽ",
  "propertyDetails.noReviews": "ምንም ምላሽ አልተሰጠም። መጀመሪያ እንደምትሆን እባኮትን እንዲፈትሹ",
  "propertyDetails.postReview": "ምላሽ አስተላልፍ",
  "propertyDetails.writeReview": "ምላሽ ጻፉ",
  "propertyDetails.submitReview": "አስቀምጥ",
  "propertyDetails.errorReview": "ምላሽ መላክ ተሳክቶ አልተቻለም",
  "propertyDetails.selectRating": "እባኮትን ደረጃ ይምረጡ",
  "propertyDetails.writeSomething": "እባኮትን በምላሽ ላይ ነገር አስገቡ",
  "activeFilters": "ንብረት ፍለጋ",
  "yes": "አዎን",
  "no": "አይ",
  "total": "ጠቅላላ",
  "filtered": "ተጠቀሰ",
  "loadingProperties": "ንብረቶችን እየጫነን...",
  "errorOccurred": "ስህተት ተፈጥሯል: {{error}}",
  "retry": "እንደገና ሞክሩ",
  "noPropertiesFound": "ምንም ንብረቶች አልተገኙም",
  "noPropertiesMatchCriteria": "ተመሳሳይ ንብረቶች አልተመኙም",
  "noPropertiesAvailable": "ምንም ንብረቶች አልተለጠፉም",
  "clearFilters": "ፍለጋ አጽዳ",
  "refresh": "ተመልከት",
  "initializingFilters": "ፍለጋ እንደ ማነቃቂያ...",
  "search": "ፍለጋ",
  "type": "አይነት",
  "location": "ቦታ",
  "bedrooms": "እንቁላል",
  "bathrooms": "መታጠቢያ ክፍል",
  "amenities": "ሰላምታዎች",
  "writeReview": "እባኮትን ግምት ይጻፉ",
  "submitReview": "ግምት አስተዋፅኦ",
  "postReview": "ሪቪው እንዲላኩ",
  "loginToReview": "እባኮትን ሪቪው ለመጻፍ ይግቡ",
  "writeSomething": "በግምት ላይ ምንም እባኮትን ጻፉ",
  "selectRating": "እባኮትን ምርጫ ይምረጡ",
  "errorReview": "እባኮትን ለሪቪው መላክ ይግቡ",
  "submitReviewSuccess": "ግምት ተሳክቷል!",
  "rent" : "ይከራዩ",
  "buy": "ይግዙ",
  "from" : "ከ",
  "to" : "ለ",
  "owner" : "ባለቤት",
  "agent" : "ወኪል",
   "choosepostedby" : "የተለጠፈውን ይምረጡ",
   "propertypostedby" : "የተለጠፈው ንብረት",
   "typeofproperty" : "የንብረት አይነት",
   "floorpreference" : "የወለል ምርጫ",
   "budgetrange" : "የበጀት ክልል",
   "minbudget" : "ዝቅተኛ በጀት",
   "maxbudget" : "ከፍተኛ በጀት",
   "monthly" : "ወርሃዊ",
   "yearly" : "በየአመቱ",
   "furnishingstatus" : "የቤት ዕቃዎች ሁኔታ",
   "selectfurnishing" : "የቤት ዕቃዎችን ይምረጡ",
   "selectfloor" : "ወለል ይምረጡ",
  "roomsandsleepingarrangements" : "የመኝታ ክፍሎች እና ክፍሎች",
  "amenitiesoffered" : "የቀረቡ መገልገያዎች",
  "features" : "ባህሪያት",
  "clearall" : "ሁሉንም አጽዳ",
  "applyfilters" : "ማጣሪያዎችን ተግብር",
  "whatisyourintendeddurationofstay" : "የሚቆይበት ጊዜ ምን ያህል ነው የታሰበው?",
  "searchproperties" : "የፍለጋ ባህሪያት",
  "propertytype" : "የንብረት አይነት",
  "apartment" : "አፓርትመንት",
  "alllocation" : "ሁሉም ቦታዎች",
  "browseproperties" : "ንብረቶችን አስስ",
  "login" : "ግባ",
  "signup" :"ይመዝገቡ",
  "english" : "እንግሊዝኛ",
  "amharic" : "አማርኛ",
  "aed" : "ኤኢዲ",
  "etb" : "ኢ.ቲ.ቢ",
  "usd" : "የአሜሪካ ዶላር",

    // Add other keys if needed



  "writeUs": "ለኛ ይጻፉ",
    "callUs": "ይደውሉልን",
  "appInformation": "መተግበሪያ መረጃ",
        "account": "የመለያ ስም",

 "home": "መነሻ",
    "post": "ማስታወቂያ",
    "profile": "መገለጫ",
    "saved": "የተቀመጡ"

};

export default amTranslations;
